var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAirport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 550 489",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M272 262H107a17 17 0 0 1-17-16v-86a17 17 0 0 1 17-17h165a17 17 0 0 1 17 17v86a17 17 0 0 1-17 16Zm219 0H325a17 17 0 0 1-17-16v-86a17 17 0 0 1 17-17h166a17 17 0 0 1 16 17v86a17 17 0 0 1-16 16ZM289 405H90V296a17 17 0 0 1 17-17h165a17 17 0 0 1 17 17Zm218 0H308V296a17 17 0 0 1 17-17h166a17 17 0 0 1 16 17Zm-16-279H325a17 17 0 0 1-17-16V17a17 17 0 0 1 17-17h166a17 17 0 0 1 16 17v93a17 17 0 0 1-16 16Zm-219 0H107a17 17 0 0 1-17-16V17a17 17 0 0 1 17-17h165a17 17 0 0 1 17 17v93a17 17 0 0 1-17 16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M502 410H100a10 10 0 0 1 0-19h402a10 10 0 0 1 0 19Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M283 400H119v-38a82 82 0 0 1 164 0Zm196 0H315v-38a82 82 0 0 1 164 0Zm-77 88h-13v-84h13z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "m353 487 44 1 44-1c0-1-20-12-44-12s-44 11-44 12Zm-147 1h-13v-84h13z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "m157 487 44 1 44-1c0-1-20-12-44-12s-44 11-44 12Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0616a",
    d: "M258 476h13l6-47h-19v47z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M294 487h-38v-14h23a15 15 0 0 1 15 14Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0616a",
    d: "m278 469 11-3-8-47-18 5 15 45z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "m315 469-37 12-4-14 23-7a15 15 0 0 1 18 9Zm-46-22-22-58c-5 1-47 10-61-5-5-5-6-13-3-22l8-11c3 1 77 5 82 27l14 63a5 5 0 0 1-3 6l-9 3a4 4 0 0 1-1 0 5 5 0 0 1-5-3Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "m256 454-22-58c-5 1-47 10-61-5-5-5-6-13-3-22l8-11c3 1 77 5 82 27l14 63a5 5 0 0 1-3 6l-9 3a4 4 0 0 1-1 0 5 5 0 0 1-5-3Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0616a",
    d: "M236 340a19 19 0 0 1-16-9l-7-12 17-9 7 9 48-5a11 11 0 0 1 1-1 11 11 0 0 1 8-4 11 11 0 0 1 9 3 11 11 0 0 1 1 13 11 11 0 0 1-16 3l-47 12a19 19 0 0 1-5 0Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M169 372a5 5 0 0 1-1-4c2-19-1-45-4-64a25 25 0 0 1 28-29 80 80 0 0 1 10 2 25 25 0 0 1 18 25c0 18 3 41 5 50a5 5 0 0 1-1 3 4 4 0 0 1-3 2c-18 2-37 10-47 15a5 5 0 0 1-2 1 4 4 0 0 1-3-1Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M218 325a4 4 0 0 1-3-3l-10-23a11 11 0 1 1 21-9l10 23a5 5 0 0 1-2 6l-13 6a4 4 0 0 1-3 0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 189.8,
    cy: 243,
    r: 24.6,
    fill: "#a0616a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M175 265a4 4 0 0 1-6 0 44 44 0 0 1-12-16c-4-8-4-17 0-24 3-6 8-10 14-13a23 23 0 0 1 6-3 9 9 0 0 1 8 1 8 8 0 0 1 3 7 22 22 0 0 1 9-7 11 11 0 0 1 8-1c3 2 6 5 7 9a19 19 0 0 1 2 9 11 11 0 0 1-5 8c-2 2-6 2-9 1l-11-3c-4-1-7 1-9 4l-2 7-1 14a19 19 0 0 1-2 6 3 3 0 0 1 0 1Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0616a",
    d: "M227 366a11 11 0 0 1-6-6 10 10 0 0 1 0-1l-53-15a11 11 0 0 1-8-11v-20l20 1 1 12 45 20a11 11 0 0 1 1-1 11 11 0 1 1 0 21Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M161 322a4 4 0 0 1-2-3l2-25a11 11 0 1 1 23 1l-2 25a5 5 0 0 1-4 4h-14a4 4 0 0 1-3-2Zm136 13h-14a2 2 0 0 1-2-2l-3-29h24l-3 29a2 2 0 0 1-2 2Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M302 308h-24a2 2 0 0 1-1-2v-5a2 2 0 0 1 1-2h24a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2Zm-217 1H56a3 3 0 0 0-3 3v60h5v-56a3 3 0 0 1 3-3h20a3 3 0 0 1 4 3v56h4v-60a3 3 0 0 0-3-4Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M104 488H35a13 13 0 0 1-13-14V374a13 13 0 0 1 13-13h69a13 13 0 0 1 13 13v100a13 13 0 0 1-13 14Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M23 444c-4 0-7-10-7-19s3-18 7-18 7 9 7 18-2 19-7 19Zm0-36c-2 0-5 7-5 17s3 17 5 17 6-7 6-17-3-17-6-17Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M99 428H86a4 4 0 0 1-4-4v-9a4 4 0 0 1 4-4h13a4 4 0 0 1 4 4v9a4 4 0 0 1-4 4Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M103 481H30a2 2 0 0 1-1-2V369a2 2 0 0 1 1-2h73a2 2 0 1 1 0 3H32v108h71a2 2 0 0 1 0 3Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M810 390a9 9 0 0 0-3-2 21 21 0 0 0-9 0 37 37 0 0 0-5 0l-92 26-5 2c-6-2-22-9-24-12l-7 3 12 17a2 2 0 0 0 0 3c14 5 34-1 34-1l80-23s24-8 19-13Z",
    style: {
      isolation: "isolate"
    },
    transform: "translate(-325 -206)"
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "m440 199-52 14-3 6 55-20z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M549 489H1a1 1 0 0 1 0-2h548a1 1 0 0 1 0 2Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M439 88a15 15 0 0 0-11 4 11 11 0 0 0-15 11h41a15 15 0 0 0-15-15ZM219 39a15 15 0 0 0-11 4 11 11 0 0 0-15 11h41a15 15 0 0 0-15-15Zm-68 131a15 15 0 0 0-11 4 11 11 0 0 0-15 11h41a15 15 0 0 0-15-15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirport);
export default __webpack_public_path__ + "static/media/airport.95f585a335de85c8287bf0d7e24ca442.svg";
export { ForwardRef as ReactComponent };